import * as React from "react";
import { useRef, useEffect, useState, useMemo } from "react";
import CameraPTZ from "./CameraPTZ";
import styled from "styled-components";
import { colors } from "../../maps/colors";
import { calculateContainerHeight } from "../../utils";

const RotationgInfoStyled = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
  background-color: ${colors.BLACK_WITH_HALF_TRANS};
  width: 30px;
  height: 10px;
  font-size: 18px;
  color: #fff;
  text-align: center;

  div {
    font-size: 10px;
    margin: 0;
    padding: 0;
    line-height: 1;
  }
`;

const CameraName = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #121212;
  color: #fff;
  padding: 1px 4px;
`;

export default function CameraLive(props) {
  const {
    resolution,
    camera,
    rotate,
    rotateEnabled,
    disableControls,
    children,
    rtspUrl,
    showCameraName,
    dynamicWidth,
  } = props;

  let rotateValue = rotate;
  if (camera) {
    rotateValue = camera.rotate;
  }

  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const [videoHeight, s_videoHeight] = useState("100%");
  const [videoWidth, s_videoWidth] = useState("100%");
  const [height, s_height] = useState("100%");
  const [width, s_width] = useState("100%");
  const [show, s_show] = useState(false);
  const encode_uri_rtsp_url = (rtspUrl) =>
    `${rtspUrl?.split("?")?.[0]}${
      rtspUrl?.trim()?.split("?")?.length > 1
        ? escape("?" + rtspUrl?.split("?")?.[1])
        : ""
    }`;

  useEffect(() => {
    if (ref.current && wrapperRef.current) {
      const isRotateFixNeeded = rotateValue === 90 || rotateValue === 270;
      const parentWidth = wrapperRef.current.parentElement.offsetWidth;
      const pageHeight = document.body.clientHeight;
      const r_width = parseInt(resolution.split("x")[0]);
      const r_height = parseInt(resolution.split("x")[1]);

      let camWidth = 0;
      let camHeight = 0;
      if (dynamicWidth) {
        const profile = camera?.profile_list?.find(
          (pp) => pp.name === camera.viewProfile
        );
        if (profile) {
          const bound = profile?.video?.source?.bounds;
          if (bound) {
            camWidth = bound.width;
            camHeight = bound.height;
          }
        }
      }

      let initialHeight = "initial";
      if (isRotateFixNeeded) {
        initialHeight =
          parentWidth > pageHeight ? parseInt(pageHeight * 0.7) : parentWidth;
        s_height(initialHeight);
        s_videoHeight((initialHeight / r_width) * r_height);
        s_width(initialHeight);
      } else {
        const ar = r_width / r_height;
        let actual_width = parentWidth;
        let actual_height = actual_width / ar;
        if (dynamicWidth) {
          actual_height = calculateContainerHeight(
            camWidth,
            camHeight,
            parentWidth
          );
        }
        s_height(actual_height);
        s_videoHeight(actual_height);
        s_width(actual_width);
      }
      s_show(true);
    }
  }, [ref.current, wrapperRef.current]);

  const getMargin = () => {
    if (rotateEnabled && rotateValue) {
      if (rotateValue === 90 || rotateValue === 90) {
        return "50px 0 50px 0";
      }
    }
    return 0;
  };

  const getTransform = () => {
    if (rotateValue) {
      return rotateValue;
    }
    return 0;
  };
  const cam_id = `${camera?.cameraId}`;
  const publicEdgeIp = rtspUrl!==""? rtspUrl.split("@")[1].split("/")[0].split(":")[0] :"";

  // const camUrl = `http://${publicEdgeIp}.whatson-pay.com:8888/camera_${cam_id}`; // this is local IP
  const camUrl = `https://${publicEdgeIp}.cameras.whatson-pay.com/camera_${cam_id}`; // this is local IP



  // console.log(camUrl, `http://${publicEdgeIp}:8888/camera_${cam_id}`);

  return (
    <div
      ref={wrapperRef}
      style={{
        width: width,
        height: height,
        position: "relative",
        background: "black",
        display: "grid",
        alignItems: "center",
      }}
    >
      {showCameraName && <CameraName>{camera.name}</CameraName>}

      <div
        ref={ref}
        style={{
          height: videoHeight,
          width: width,
          fontSize: 0,
          margin: getMargin(),
          transform: `rotate(${getTransform()}deg)`,
        }}
      >
        {show && (
          <>
            {
              <iframe
                src={camUrl}
                width="100%"
                height="100%"
                allow="autoplay"
                frameBorder="0"
                title={`Camera Stream  `}
              ></iframe>
            }
            &&
            {
              // <iframe
              //   id="fp_embed_player"
              //   src={`https://whatson-live.whatson-pay.com:8444/embed_player?urlServer=wss://whatson-live.whatson-pay.com:8443&streamName=${encode_uri_rtsp_url(
              //     rtspUrl
              //   )}&autoplay=true&resolution=${
              //     props.resolution ? props.resolution : "600x400"
              //   }`}
              //   marginWidth="0"
              //   marginHeight="0"
              //   frameBorder="0"
              //   width="100%"
              //   height="100%"
              //   scrolling="no"
              //   allowFullScreen="allowfullscreen"
              // ></iframe>
            }
            {camera && !disableControls && (camera.pt || camera.z) && (
              <CameraPTZ {...camera} />
            )}
            {camera && (
              <RotationgInfoStyled>
                <div>R:{rotateValue}</div>
              </RotationgInfoStyled>
            )}
          </>
        )}
        {children}
      </div>
    </div>
  );
}
